import Proptypes from 'prop-types';
import React from 'react'

import { Col, Separator } from 'twyne-new.ui';

import { formatters } from '../utils';

export default function DefaultToolbar({ editor }) {
  return <Col size="12" className='flex border twy-border-base p-1 align-center'>
    {formatters.clearFormatter(editor)}
    {formatters.titleFormatters(editor)}
    <Separator className="mx-2 h-4" orientation='vertical' />
    {formatters.markFormatters(editor)}
    <Separator className="mx-2 h-4" orientation='vertical' />
    {formatters.alignFormatters(editor)}
    <Separator className="mx-2 h-4" orientation='vertical' />
    {formatters.colorFormatters(editor)}
    <Separator className="mx-2 h-4" orientation='vertical' />
    {formatters.scriptFormatters(editor)}
    <Separator className="mx-2 h-4" orientation='vertical' />
    {formatters.listFormatters(editor)}
    <Separator className="mx-2 h-4" orientation='vertical' />
    {formatters.linkFormatters(editor)}
    <Separator className="mx-2 h-4" orientation='vertical' />
    {formatters.specialFormatters(editor)}
  </Col>
}

DefaultToolbar.propTypes = {
  editor: Proptypes.object,
}
